var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgT6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_152_561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2385 15.4142L7.83441 28.3832C7.75015 28.5308 7.56128 28.5785 7.41546 28.4913C2.82811 25.747 0 20.7743 0 15.4142C0 7.05465 6.87887 0.175781 15.2385 0.175781C23.4946 0.175781 30.3066 6.88562 30.4738 15.1048C30.4772 15.2744 30.3416 15.4142 30.172 15.4142H15.2385Z",
    fill: "url(#paint0_radial_152_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2395 15.4143L8.16957 27.7981C3.71661 25.268 0.984375 20.5358 0.984375 15.4143C0.984375 7.59419 7.41939 1.15918 15.2395 1.15918C23.0596 1.15918 29.4946 7.59419 29.4946 15.4143H15.2395Z",
    fill: "url(#paint1_linear_152_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2387 12.2785C20.3455 12.2785 24.4853 9.87224 24.4853 6.90392C24.4853 3.9356 20.3455 1.5293 15.2387 1.5293C10.132 1.5293 5.99219 3.9356 5.99219 6.90392C5.99219 9.87224 10.132 12.2785 15.2387 12.2785Z",
    fill: "url(#paint2_linear_152_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0681 1.8125C23.0867 3.85642 23.6608 6.16061 23.6608 8.59939C23.6608 11.0491 23.0818 13.3634 22.0547 15.4141H30.4756C30.4756 15.2952 30.4738 15.1766 30.471 15.0583C30.4704 15.0325 30.4696 15.0067 30.4689 14.9809C30.3056 9.25225 26.9152 4.27299 22.0681 1.8125V1.8125Z",
    fill: "url(#paint3_linear_152_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7397 25.7412C30.7387 23.2022 31.9485 20.0129 31.9974 16.5425C31.9991 16.4218 31.9005 16.3232 31.7799 16.3232H17.5434C17.2821 16.3232 17.1659 16.6515 17.3689 16.8159L28.4331 25.7744C28.5268 25.8503 28.6652 25.8359 28.7397 25.7412V25.7412Z",
    fill: "url(#paint4_linear_152_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9918 16.9023H19.6762C19.415 16.9023 19.2988 17.2306 19.5017 17.395L29.1468 25.2045C30.8387 22.8503 31.8762 19.9944 31.9918 16.9023V16.9023Z",
    fill: "url(#paint5_linear_152_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7842 16.3232H30.6629C30.0928 17.3487 29.3944 18.3241 28.5662 19.2265C27.3219 20.5824 25.8885 21.661 24.3438 22.4598L28.4374 25.7744C28.531 25.8503 28.6695 25.8359 28.7441 25.7412C30.743 23.2022 31.9528 20.0129 32.0017 16.5425C32.0035 16.4218 31.9049 16.3232 31.7842 16.3232Z",
    fill: "url(#paint6_linear_152_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2769 16.3223C27.0956 18.7595 26.1919 20.9948 24.7782 22.8147L17.3688 16.8151C17.1661 16.651 17.2821 16.3223 17.543 16.3223H27.2769Z",
    fill: "url(#paint7_radial_152_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4639 16.8683L8.20827 29.5781C8.13097 29.7135 8.1811 29.885 8.31789 29.9599C10.4875 31.1479 12.9776 31.8236 15.6256 31.8236C20.3052 31.8236 24.4914 29.7135 27.2867 26.3937C27.3873 26.2743 27.3719 26.0961 27.2506 25.9979L15.8791 16.7903C15.7462 16.6828 15.5486 16.7199 15.4639 16.8683V16.8683Z",
    fill: "url(#paint8_radial_152_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6269 31.8239C20.1761 31.8239 24.2586 29.8296 27.0507 26.6685L16.3535 18.0071C16.2206 17.8996 16.0231 17.9367 15.9383 18.0851L8.96875 30.2939C10.9805 31.2729 13.2391 31.8239 15.6269 31.8239V31.8239Z",
    fill: "url(#paint9_linear_152_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2506 25.9986L23.6641 23.0947C20.8141 27.1343 16.1112 29.7731 10.7916 29.7731C9.91488 29.7731 9.05533 29.7002 8.21769 29.5624L8.20827 29.5789C8.13097 29.7143 8.18111 29.8857 8.31789 29.9607C10.4875 31.1487 12.9776 31.8243 15.6256 31.8243C20.3052 31.8243 24.4914 29.7143 27.2867 26.3944C27.3873 26.275 27.3719 26.0968 27.2506 25.9986Z",
    fill: "url(#paint10_linear_152_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1867 23.5166C21.9773 25.9562 18.7839 27.489 15.2334 27.489C13.3828 27.489 11.63 27.0726 10.0625 26.329L15.4637 16.868C15.5488 16.7198 15.7459 16.6827 15.8792 16.7907L24.1867 23.5166Z",
    fill: "url(#paint11_radial_152_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2365 23.5492C19.7293 23.5492 23.3715 19.9071 23.3715 15.4143C23.3715 10.9214 19.7293 7.2793 15.2365 7.2793C10.7437 7.2793 7.10156 10.9214 7.10156 15.4143C7.10156 19.9071 10.7437 23.5492 15.2365 23.5492Z",
    fill: "url(#paint12_linear_152_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.235 23.0246C19.4378 23.0246 22.845 19.6175 22.845 15.4147C22.845 11.2118 19.4378 7.80469 15.235 7.80469C11.0321 7.80469 7.625 11.2118 7.625 15.4147C7.625 19.6175 11.0321 23.0246 15.235 23.0246Z",
    fill: "url(#paint13_linear_152_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2331 13.7404C17.9593 13.7404 20.1693 12.4558 20.1693 10.8712C20.1693 9.28654 17.9593 8.00195 15.2331 8.00195C12.5069 8.00195 10.2969 9.28654 10.2969 10.8712C10.2969 12.4558 12.5069 13.7404 15.2331 13.7404Z",
    fill: "url(#paint14_linear_152_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.877 8.1377C19.4256 9.23272 19.7349 10.4685 19.7349 11.7767C19.7349 16.2695 16.0927 19.9116 11.6 19.9116C10.2918 19.9116 9.05603 19.6024 7.96094 19.0537C9.29659 21.7195 12.0533 23.5497 15.2379 23.5497C19.7307 23.5497 23.3728 19.9076 23.3728 15.4148C23.3728 12.2301 21.5426 9.47335 18.877 8.1377V8.1377Z",
    fill: "url(#paint15_linear_152_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3498 19.3678C21.3808 21.1088 19.7904 22.4555 17.8791 23.1107L13.033 18.2647C11.5247 16.7563 10.3569 15.5893 10.3506 15.583C9.96588 15.2653 9.77344 14.763 9.77344 14.077V11.9906C9.77344 11.3055 9.96581 10.8032 10.3506 10.4846C10.7354 10.1661 11.2558 10.0068 11.911 10.0068C12.5615 10.0068 13.0827 10.1661 13.4754 10.4846L15.6918 12.7034L22.3498 19.3678Z",
    fill: "url(#paint16_linear_152_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3712 15.4141C23.3712 16.8492 22.9998 18.1975 22.347 19.3676C21.3779 21.1086 19.7875 22.4554 17.8763 23.1106C17.0483 23.3952 16.1605 23.549 15.2364 23.549C15.0046 23.549 14.7751 23.5395 14.5488 23.5198L12.1881 21.1812C12.0312 21.0195 11.9531 20.8405 11.9531 20.645C11.9531 20.5567 11.9768 20.4637 12.0249 20.3659L13.0302 18.2645L15.689 12.7033L17.0909 9.77173C17.206 9.52728 17.4079 9.4043 17.6972 9.4043C17.9125 9.4043 18.1112 9.47765 18.2926 9.6251C18.3738 9.69054 18.4361 9.76546 18.481 9.84665L23.3405 14.7069C23.361 14.9402 23.3712 15.176 23.3712 15.4141V15.4141Z",
    fill: "url(#paint17_linear_152_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1162 15.2158C19.7239 14.8976 19.2025 14.7383 18.552 14.7383C17.8963 14.7383 17.3761 14.8977 16.9913 15.2158C16.6064 15.5343 16.4141 16.0364 16.4141 16.7219V18.8084C16.4141 19.4942 16.6064 19.9963 16.9913 20.3145C16.9976 20.3198 17.9272 21.2489 19.1985 22.5202C20.519 21.783 21.6134 20.6894 22.3491 19.3676C22.5837 18.9472 22.7813 18.5035 22.939 18.0413L20.1162 15.2158Z",
    fill: "url(#paint18_linear_152_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.064 14.077V11.9905C14.064 11.3049 13.8678 10.8028 13.4756 10.4844C13.0832 10.1661 12.5618 10.0068 11.9114 10.0068C11.2557 10.0068 10.7354 10.1662 10.3506 10.4844C9.96581 10.8028 9.77344 11.3049 9.77344 11.9905V14.077C9.77344 14.7627 9.96581 15.2649 10.3506 15.5831C10.7354 15.9015 11.2557 16.0606 11.9114 16.0606C12.5618 16.0606 13.0832 15.9015 13.4756 15.5831C13.8678 15.2649 14.064 14.7627 14.064 14.077V14.077ZM12.6534 14.077C12.6534 14.5471 12.406 14.7822 11.9114 14.7822C11.4265 14.7822 11.184 14.5471 11.184 14.077V11.9905C11.184 11.5202 11.4265 11.2852 11.9114 11.2852C12.406 11.2852 12.6534 11.5203 12.6534 11.9905V14.077Z",
    fill: "url(#paint19_linear_152_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5648 10.183C18.5648 9.95777 18.4742 9.77154 18.2928 9.62466C18.1114 9.47771 17.9128 9.4043 17.6972 9.4043C17.4084 9.4043 17.2063 9.5269 17.0911 9.77161L12.0252 20.3657C11.9769 20.4638 11.9531 20.5567 11.9531 20.6449C11.9531 20.8407 12.0316 21.0196 12.1887 21.1812C12.3457 21.3428 12.542 21.4236 12.7775 21.4236C13.0948 21.4236 13.3113 21.301 13.4271 21.0563L18.5072 10.4622C18.5455 10.3839 18.5648 10.2909 18.5648 10.183V10.183Z",
    fill: "url(#paint20_linear_152_561)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1162 15.2158C19.7238 14.8976 19.2025 14.7383 18.552 14.7383C17.8962 14.7383 17.376 14.8977 16.9912 15.2158C16.6064 15.5343 16.4141 16.0364 16.4141 16.7219V18.8084C16.4141 19.4942 16.6064 19.9963 16.9912 20.3145C17.376 20.6329 17.8962 20.792 18.552 20.792C19.2025 20.792 19.7238 20.6329 20.1162 20.3145C20.5084 19.9963 20.7046 19.4942 20.7046 18.8084V16.7219C20.7046 16.0364 20.5083 15.5342 20.1162 15.2158ZM19.294 18.8084C19.294 19.2786 19.0465 19.5137 18.552 19.5137C18.0671 19.5137 17.8246 19.2786 17.8246 18.8084V16.7219C17.8246 16.2518 18.0671 16.0166 18.552 16.0166C19.0465 16.0166 19.294 16.2518 19.294 16.7219V18.8084Z",
    fill: "url(#paint21_linear_152_561)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_152_561",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1468 7.55097) scale(20.8358 20.8358)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCE3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAE2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_152_561",
    x1: 15.2107,
    y1: 15.4118,
    x2: 2.03235,
    y2: 2.23343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCEE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_152_561",
    x1: 16.2466,
    y1: 11.1728,
    x2: 13.4756,
    y2: -0.56457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_152_561",
    x1: 24.4172,
    y1: 12.0627,
    x2: 32.6566,
    y2: -3.26152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_152_561",
    x1: 23.9564,
    y1: 15.9367,
    x2: 31.3682,
    y2: 23.0331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_152_561",
    x1: 26.6262,
    y1: 22.3541,
    x2: 24.5761,
    y2: 10.6846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_152_561",
    x1: 27.9677,
    y1: 21.6953,
    x2: 34.7975,
    y2: 8.9928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1272D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_152_561",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.286 16.1236) scale(7.64023 7.64021)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1272D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5053,
    stopColor: "#C3272C",
    stopOpacity: 0.495
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6873,
    stopColor: "#CA2729",
    stopOpacity: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#D52724",
    stopOpacity: 0.183
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    stopColor: "#E6281C",
    stopOpacity: 0.079
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_152_561",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.2333 16.6755) scale(15.1613 15.1613)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A98F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_152_561",
    x1: 16.7558,
    y1: 26.5737,
    x2: 9.34403,
    y2: 15.2983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65E1DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_152_561",
    x1: 19.1916,
    y1: 26.569,
    x2: 34.4093,
    y2: 11.2724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0469BC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_152_561",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.139 17.575) scale(7.73107 7.73106)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0469BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8532,
    stopColor: "#0469BC",
    stopOpacity: 0.147
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_152_561",
    x1: 7.10156,
    y1: 15.4143,
    x2: 23.3715,
    y2: 15.4143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_152_561",
    x1: 15.38,
    y1: 15.4932,
    x2: 8.24417,
    y2: 11.6296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EDF5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_152_561",
    x1: 15.2331,
    y1: 12.9699,
    x2: 15.2331,
    y2: 8.42768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EDF5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_152_561",
    x1: 16.1503,
    y1: 16.7671,
    x2: 35.2317,
    y2: 7.30525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_152_561",
    x1: 15.7409,
    y1: 16.8441,
    x2: 6.63392,
    y2: 10.0631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_152_561",
    x1: 18.1595,
    y1: 17.4795,
    x2: 12.6401,
    y2: 14.5621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_152_561",
    x1: 21.7873,
    y1: 19.8198,
    x2: 15.0457,
    y2: 16.7053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_152_561",
    x1: 11.9191,
    y1: 13.0382,
    x2: 13.9166,
    y2: 22.3423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_152_561",
    x1: 14.6248,
    y1: 12.4565,
    x2: 16.6224,
    y2: 21.7607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_152_561",
    x1: 17.2961,
    y1: 11.8836,
    x2: 19.2936,
    y2: 21.1879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555A66"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_152_561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgT6);
export default __webpack_public_path__ + "static/media/t6.d73f1d7654da5014a62e0895832fd7ee.svg";
export { ForwardRef as ReactComponent };